export const nameCreateRegex = /^[0-9a-zA-Z\-_\u4e00-\u9fa5]{2,}$/;
export const idCreateRegex = /^[a-zA-Z][0-9a-zA-Z_]*$/;
export const typeNameRegex = /^[A-Z][0-9a-zA-Z]*$/;
export const propertyNameRegex = /^[a-z][0-9a-zA-Z]*$/;

export const orgLabelRegex = /^[a-zA-Z][0-9a-zA-Z_]*$/;
export const agentLabelRegex = /^[a-zA-Z][0-9a-zA-Z]*$/;

export const characterBlackNameRegex = new RegExp(
  "^[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_" +
  '"]'
);
export const urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
